module.exports = __webpack_public_path__ + "img/28_29.0c26b574.png";